import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-landing',
  standalone: true,
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
  imports: [CommonModule, RouterModule, FontAwesomeModule],
})
export class LandingComponent implements OnInit {
  isHeaderCollapsed = false;
  private scrollThreshold = 50;
  private lastScrollPosition = 0;

  faFacebookF = faFacebookF;
  faLinkedinIn = faLinkedinIn;
  faYoutube = faYoutube;
  faInstagram = faInstagram;

  salesforceUrl = environment.SALESFORCE_AUTH.extLoginUrl;
  salesforcePortalUrl = environment.PORTAL_URLS.salesforce;
  employerPortalUrl = environment.PORTAL_URLS.employer;
  employeePortalUrl = environment.PORTAL_URLS.employee;

  showSalesforce2 = environment.PORTAL_2_TOGGLE?.salesforce ?? false;
  showEmployer2 = environment.PORTAL_2_TOGGLE?.employer ?? false;
  showEmployee2 = environment.PORTAL_2_TOGGLE?.employee ?? false;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const currentScrollPosition =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (
      currentScrollPosition > this.lastScrollPosition &&
      currentScrollPosition > this.scrollThreshold
    ) {
      this.isHeaderCollapsed = true;
    } else if (
      currentScrollPosition < this.lastScrollPosition ||
      currentScrollPosition <= this.scrollThreshold
    ) {
      this.isHeaderCollapsed = false;
    }
    this.lastScrollPosition =
      currentScrollPosition <= 0 ? 0 : currentScrollPosition;


  }

}
